const zhCommon = {
  "site.name": "八戒影院",
  "site.slogan": "电影大全免费观看高清不缓冲",
  "site.description": "八戒影视为您打造电影大全免费观看库，高清不缓冲。涵盖最新热门影片与免费电影，电视剧全集同步更新，在线畅看。",
  "nav.home": "首页",
  "nav.category": "分类",
  "nav.about": "关于我们",
  "nav.all": "全部",
  "hero.title": "畅享无限影视世界",
  "hero.subtitle": "高清画质 · 海量资源 · 每日更新 · 免费观看",
  "hero.cta": "立即观影",
  "section.featured": "热门推荐",
  "section.latest": "最新上线",
  "section.tvseries": "电视剧专区",
  "section.faq": "常见问题",
  "section.related": "相关推荐",
  "category.all": "全部影片",
  "category.action": "动作片",
  "category.comedy": "喜剧片",
  "category.romance": "爱情片",
  "category.scifi": "科幻片",
  "category.horror": "恐怖片",
  "category.animation": "动画片",
  "category.tvseries": "电视剧",
  "category.documentary": "纪录片",
  "movie.director": "导演",
  "movie.cast": "主演",
  "movie.genre": "类型",
  "movie.duration": "片长",
  "movie.year": "年份",
  "movie.region": "地区",
  "movie.rating": "评分",
  "movie.synopsis": "剧情简介",
  "movie.watch": "立即观看",
  "breadcrumb.home": "首页",
  "about.title": "关于八戒影院",
  "about.intro": "品牌介绍",
  "about.reputation": "口碑评价",
  "about.contact": "联系我们",
  "about.intro.text": "八戒影院成立于2020年，是一家专注于为用户提供高品质影视内容的在线平台。我们致力于打造国内领先的电影大全免费观看网站，让每一位用户都能享受到高清不缓冲的观影体验。平台涵盖最新热门影片、经典电影、热门电视剧等多种类型，资源丰富，每日同步更新。",
  "about.mission": "我们的使命",
  "about.mission.text": "让每一个热爱影视的人都能轻松找到并观看自己喜欢的作品，无需付费，无需等待，高清流畅，随时随地。",
  "about.vision": "我们的愿景",
  "about.vision.text": "成为中国最受欢迎的免费影视内容平台，以海量资源、极致画质和流畅体验赢得用户的信赖与喜爱。",
  "footer.copyright": "© 2026 八戒影院 版权所有",
  "footer.disclaimer": "本站所有内容均来自网络公开资源，仅供交流学习使用。如涉及版权问题，请联系我们处理。",
  "footer.links": "快速链接",
  "footer.contact": "联系方式",
  "faq.q1": "八戒影院的视频需要付费吗？",
  "faq.a1": "不需要！八戒影院所有的影视内容都是免费观看的，无需注册登录，无需支付任何费用。我们致力于为广大影迷提供最便捷的免费观影渠道。",
  "faq.q2": "影片画质如何？会不会卡顿？",
  "faq.a2": "我们提供的影片均为高清画质，支持1080P甚至更高分辨率。平台采用先进的CDN加速技术，确保播放流畅不缓冲，给您极致的观影体验。",
  "faq.q3": "影片更新速度快吗？",
  "faq.a3": "非常快！我们的内容团队每日跟进各大影视平台的最新动态，第一时间更新热门电影和电视剧，确保您不会错过任何精彩内容。",
  "faq.q4": "支持哪些设备观看？",
  "faq.a4": "八戒影院支持电脑、平板、手机等多种设备观看，采用响应式设计，自动适配不同屏幕尺寸，让您随时随地畅享影视盛宴。",
  "faq.q5": "如何找到我想看的影片？",
  "faq.a5": "您可以通过首页的分类导航按类型筛选影片，也可以使用搜索功能直接查找。我们的影片分类清晰，查找方便快捷。",
  "contact.email": "电子邮箱",
  "contact.email.value": "service@bajiecinema.com",
  "contact.phone": "客服电话",
  "contact.phone.value": "400-000-0000",
  "contact.address": "公司地址",
  "contact.address.value": "北京市朝阳区建国路88号八戒影视大厦",
  "contact.wechat": "微信公众号",
  "contact.wechat.value": "八戒影院官方",
  "cta.newsletter": "订阅更新",
  "cta.newsletter.desc": "订阅我们的更新通知，第一时间获取最新影片上线信息",
  "cta.subscribe": "立即订阅",
};

export default zhCommon;